<template>
  <div class="chat--window">
    <div class="chat--toolbar" v-if="!noHeader">
      <v-toolbar class="transparent elevation-0" flat>
        <v-btn
          class="hidden-md-and-up"
          icon dark
          router :href="{ name: 'Messenger' }">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-toolbar-title>{{ user.name }}</v-toolbar-title>
        <v-btn
          icon dark
          router :href="{ name: 'User', params: { id: user.externalId, tab: 'profile' } }">
          <v-icon>account_circle</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </div>
    <div class="chat--content" ref="chatContent">
      <messages v-if="conversation._id" :conversation="conversation"></messages>
    </div>
    <div class="chat--form">
      <v-divider></v-divider>
      <message-form :user="user" :conversationId="conversation._id"></message-form>
    </div>
  </div>
</template>

<script>
  import MessageForm from './MessageForm.vue'
  import Messages from './Messages.vue'
  import withConversation from '@/mixins/withConversation'
  export default {
    components: {
      Messages,
      MessageForm
    },
    mixins: [withConversation],
    props: {
      noHeader: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../../variables"

  .chat--window {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    height: 100%;
  }

  .chat--toolbar {
    min-height: $toolbar-height;
    max-height: $toolbar-height;
  }

  .chat--content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    overflow: scroll;
    padding: 1em;

    > div {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/messenger/Chat.vue